import { render } from "./Delivery.vue?vue&type=template&id=ca8f1fde"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/farmfeed-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__